import React from "react";

export default function ResultsDegradation(props) {
    return (
        <div
            style={{
                backgroundColor: " rgb(255,183,233)",
                background:
                    "linear-gradient(180deg, rgba(255,183,233,1) 0%, rgba(255,129,232,1) 47%, rgba(147,0,255,1) 100%)",
                minHeight: "100vh",
            }}
        >
            <div className="hero">
                <img
                    src="https://static.igem.wiki/teams/4260/wiki/imagen/project/degradation-model/fondos-de-degradacion/moneda-molecula.png"
                    alt="Degradation coin"
                    className="w-full"
                />
                <div
                    className="fixed bottom-0 text-center w-full py-8 px-4 flex justify-around text-2xl text-white cano"
                    style={{backgroundColor: "rgba(255,129,232,.5)"}}
                >
                    <a href="#In_silico_title">In Silico Design</a>
                    <a href="#Molecular_docking_title">Molecular Docking</a>
                    <a href="#Expression_and_purification_title">Expression and Purification</a>
                    <a href="#Functionality_assays_title">Functionality Assays</a>
                    <a href="#Immobilization_title">Immobilization</a>
                    <a href="#CBZ_on_plants_title"> CBZ on Plants</a>
                    <a href="#References_title">References</a>
                </div>
                <div className="w-full flex justify-around items-center">
                    <div onClick={props.switchPage} className="p-8 clickable">
                        <svg
                            width="76.7"
                            height="135.2"
                            viewBox="0 0 59 104"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M55 4L7 52L55 100" stroke="#FFF" stroke-width="9"/>
                        </svg>
                    </div>

                    <div className="flex flex-col items-center">
                        <h2 className="text-3xl cano text-blue-900"> RESULTS </h2>
                        <h1 className="text-8xl cano text-blue-900"> DEGRADATION</h1>
                    </div>
                    <div onClick={props.switchPage} className="p-8 clickable">
                        <svg
                            width="76.7"
                            height="135.2"
                            viewBox="0 0 59 104"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path d="M4 100L52 52L4 4" stroke="#FFF" stroke-width="9"/>
                        </svg>
                    </div>
                </div>

            </div>

            <div className="h-full w-full">
                <div className="p-10 max-w-6xl m-auto pt-20 text-white">
                    <h1 className="text-6xl text-center text-white font-bold">
                        Results Degradation
                    </h1>
                    <br></br>
                    <p className="text-xl text-center">
                        {" "}
                        <font className="font-bold"> Table 1.</font> Nomenclature and
                        abbreviations for this page.
                    </p>
                    <img
                        className="figure m-auto max-w-5xl"
                        src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/t-teccem-t1-rd.png"
                        alt="abrv"
                    ></img>
                    <br></br>
                    <p className="text-xl">
                        {" "}
                        <font className="font-bold">
                            {" "}
                            <h3
                                id="In_silico_title"
                                className="text-3xl font-bold cano">In Silico design</h3>{" "}
                        </font>
                    </p>
                    <br></br>
                    <p className="text-med">
                        {" "}
                        <font className="font-bold"> Overview </font>
                    </p>
                    <p className="p-justify">
                        We have worked with the codificant region of the laccase from
                        UCL_London 2012. We added a new promoter, terminator, histidine tag
                        and a peptide signal and created this new construction. This
                        construction is called Lac_TV_HD22. We have also analyzed the
                        structure and functionalization of this coding sequence, including
                        characteristics such as molecular weight, Isoelectric point, pH
                        stability and amino acids charges, active site and diameter.
                    </p>
                    <br></br>
                    <p className="text-med">
                        {" "}
                        <font className="font-bold"> Construction LAC_TV_HD22 </font>
                    </p>
                    <p className="p-justify">
                        Length of 1864 base pairs and designed in SnapGene. We included the
                        primers site (pF_HD22 and pR_HD22), Prefix, T7 Promoter, Lac operator,
                        RBS, OmpA (periplasmic signal peptide), BBa_K729002 coding for laccase
                        from Trametes versicolor , Histidine purification tag, T7 Terminator
                        and Suffix. (Fig. 1) For further information please refer to{" "}
                        <a
                            className="underline text-blue-300"
                            href="https://2022.igem.wiki/teccem/engineering"
                        >
                            engineering.
                        </a>
                    </p>
                    <br></br>
                    <img
                        className="figure m-auto max-w-5xl"
                        src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/t-teccem-biobrick-lactv22.png"
                        alt="abLac_tv_22v"
                    ></img>
                    <p className="text-xs text-center">
                        {" "}
                        <font className="font-bold"> Fig. 1 </font>
                        <i>
                            Lac_TV_HD22. Construction of iGEM Tec Cem 2022. Designed in Snap
                            Gene and adapted from codificant region from UCL_london2012 [1,4].
                            This image shows the parts added.
                        </i>
                    </p>
                    <br></br>
                    <p className="text-med">
                        {" "}
                        <font className="font-bold"> pH Stability </font>
                    </p>
                    <p className="p-justify">
                        We have worked with the codificant region of the laccase from
                        UCL_London 2012. The PDB file of the modeled laccase was obtained in
                        iTASSER and entered into the Heatmap tool of Protein-sol [3]. Based on
                        the heatmap (Fig. 2), its optimal pH is between 5.0 and 8.0, according
                        to the green coloration.
                    </p>
                    <br></br>
                    <img
                        className="figure m-auto max-w-5xl"
                        src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/phstability.png"
                        alt="heatmap"
                    ></img>
                    <p className="text-xs text-center">
                        {" "}
                        <font className="font-bold"> Fig. 2 </font>
                        <i> Energy heatmap (Joules per aa). </i>
                    </p>
                    <br></br>
                    <p className="text-med">
                        {" "}
                        <font className="font-bold"> Lacasse diameter </font>
                    </p>
                    <p className="p-justify">
                        Lac_TV_HD22 was analyzed in the zeta-sizer pro with a DT1070 cell for
                        Zeta Potential measuring in order to obtain information about its
                        diameter when exposed to different values of pH. Sodium Phosphate
                        buffers were prepared in pH 4.0, 6.0, 7.0, and 8.0 (protocol book p.
                        10). At pH 4.0 one peak is observed in a size of 365.30 nm (named as
                        peak X), this result is attributed to protein aggregates because of an
                        unfavorable environmental condition; but after pH 5.0, a second peak
                        (named as peak Y) is observed, this peak corresponds to a folded
                        protein reaching a size of 7.5 nm. Is important to visualize that the
                        peak X, the first that appeared, diminished its size to 121.21 in a pH
                        of 5.0. This behavior continued until pH 6.0 was present. In pH 6.0,
                        the size of peak Y and peak X correspond to 6.82 nm and 81.62 nm
                        respectively, and a standard deviation of 0.53 and 23.67,
                        respectively. In pH 7.0 and 8.0, peak X increased its diameter to
                        130.70 nm and 168.03 nm respectively; peak Y also increased its
                        diameter to 8.03 nm at pH 7.0, but in pH 8.0 its diameter decreased to
                        4.98 nm with a standard deviation of 1.66. These results let us know
                        that laccase is more stable and best folded in a pH of 6.0, because:
                        peak X had the greatest decrease in comparison with the others sizes
                        (81.62 nm) with a standard deviation of 23.77; and peak Y was also the
                        littlest (6.82 nm), with a standard deviation of 0.33. Finally, pH
                        lesser or greater than 6.0 exhibits a less folded protein. Please see
                        the final report which is included below.{" "}
                    </p>
                    <br></br>
                    <div className="flex justify-center figure m-auto max-w-5xl">
                        <img
                            src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/lacdiameter1.png"
                            alt="diam 1"
                        ></img>
                        <img
                            src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/lacdiameter2.png"
                            alt="diam 2"
                        ></img>
                    </div>
                    <div className="flex justify-center figure m-auto max-w-5xl">
                        <img
                            src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/lacdiameter3.png"
                            alt="diam 3"
                        ></img>
                        <img
                            src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/lacdiameter4.png"
                            alt="diam 4"
                        ></img>
                    </div>
                    <div className="flex justify-center figure m-auto max-w-5xl">
                        <img
                            src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/lacdiameter5.png"
                            alt="diam 5"
                        ></img>
                        <img
                            src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/lacdiameter6.png"
                            alt="diam 6"
                        ></img>
                    </div>
                    {" "}
                    <br></br> <br></br>
                    <p className="text-med">
                        {" "}
                        <font className="font-bold">
                            {" "}
                            General characteristics of LAC_TV_HD22 designed in benchling{" "}
                        </font>
                    </p>
                    <br></br>
                    <p className="text-med text-center">
                        {" "}
                        <font className="font-bold">Table 2.</font> Characteristics of
                        LAC_TV_HD22 obtained from Benchling [2].
                    </p>
                    <img
                        className="figure m-auto max-w-5xl"
                        src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/numberaminoacid.png"
                        alt="tab 3"
                    ></img>
                    <br></br>
                    <p className="text-med">
                        {" "}
                        <font className="font-bold"> Amino acid sequence </font>
                    </p>
                    <p className="p-justify">
                        Sequence designed in Benchling following UC London 2012 research
                        [2,4].
                    </p>
                    <p className="p-justify">
                        M K K I T A A A G L L L L A A Q P A M A M Q R R D F L K Y S V A L G V
                        A S A L P L W S R A V F A A E R P T L P I P D L L T T D A R N R I Q L
                        T I G A G Q S T F G G K T A T T W G Y N G N L L G P A V K L Q R G K A
                        V T V D I Y N Q L T E E T T L H W H G L E V P G E V D G G P Q G I I P
                        P G G K R S V T L N V D Q P A A T C W F H P H Q H G K T G R Q V A M G
                        L A G L V V I E D D E I L K L M L P K Q W G I D D V P V I V Q D K K F
                        S A D G Q I D Y Q L D V M T A A V G W F G D T L L T N G A I Y P Q H A
                        A P R G W L R L R L L N G C N A R S L N F A T S D N R P L Y V I A S D
                        G G L L P E P V K V S E L P V L M G E R F E V L V E V N D N K P F D L
                        V T L P V S Q M G M A I A P F D K P H P V M R I Q P I A I S A S G A L
                        P D T L S S L P A L P S L E G L T V R K L Q L S M D P M L D M M G M Q
                        M L M E K Y G D Q A M A G M D H S Q M M G H M G H G N M N H M N H G G
                        K F D F H H A N K I N G Q A F D M N K P M F A A A K G Q Y E R W V I S
                        G V G D M M L H P F H I H G T Q F R I L S E N G K P P A A H R A G W K
                        D T V K V E G N V S E V L V K F N H D A P K E H A Y M A H C H L L E H
                        E D T G M M L G F T V{" "}
                    </p>
                    <br></br>
                    <p className="text-med">
                        {" "}
                        <font className="font-bold"> Active site </font>
                    </p>
                    <p className="p-justify">
                        The histidines that are part of the active site consist of: H121,
                        H123, H161, H466, H468, H519 & H521. Diagram (Fig. 3) made in PYMOL
                        [5].{" "}
                    </p>
                    <br></br>
                    <img
                        src="https://static.igem.wiki/teams/4260/wiki/lac-activesite-teccem.png"
                        alt="heatmap"
                        className="m-auto figure max-w-2xl"
                    ></img>
                    <p className="text-xs text-center">
                        {" "}
                        <font className="font-bold"> Fig. 3 </font>
                        <i> Histidines present in the active site. </i>
                    </p>
                    <br></br>
                    <p className="text-med">
                        {" "}
                        <font className="font-bold">
                            {" "}
                            Hydrophobic and hydrophilic residues{" "}
                        </font>
                    </p>
                    <p className="p-justify">
                        Finally, hydrophobic residues of the aminoacids structure of laccase
                        are shown. This prediction was obtained thanks to the ProtScale
                        bioinformatic tool from Expasy [7]. Results show hydrophobic amino
                        acids as positive values and hydrophilic residues as negative values.
                        The most hydrophobic amino acids are found in the 0-20 and 170-180
                        region and the most hydrophilic in the 160-170 region.{" "}
                    </p>
                    <br></br>
                    <img
                        className="figure m-auto"
                        src="https://static.igem.wiki/teams/4260/wiki/tecem-inter-lac-docking-500px.png"
                        alt="hydrograph"
                        width="600"
                    ></img>
                    <p className="text-xs text-center">
                        {" "}
                        <font className="font-bold"> Fig. 4 </font>
                        <i> Hydropath graphic [7]. </i>
                    </p>
                    <br></br>
                    <p className="text-xl">
                        {" "}
                        <font className="font-bold">
                            {" "}
                            <h3
                                id="Molecular_docking_title"
                                className="text-3xl font-bold cano">Molecular Docking</h3>{" "}
                        </font>
                    </p>
                    <p className="p-justify">
                        The laccase, from Trametes Versicolor (BBa_K729002), and its
                        interactions between CBZ and BPA were assessed (see figure 5 and 8).
                        The proper molecular docking was realized with the program AutoDock
                        Vina [8,9] and Chimera[10]. We obtained a score of -6.1 and -6.3
                        respectively. These two values demonstrate that the reaction is
                        spontaneous and will occur. A hydrogen bond was encountered between
                        BPA and laccase. Additionally, we identified the amino acids (A.A.)
                        that play a key role in the binding interaction. A tool from Hamburgs
                        University was used for this purpose, called “Pose View” available in
                        the website: https://proteins.plus/ [11]. The program showed that for
                        CBZ (figure 6), the key A.A. are glutamine 372 and phenylalanine 442,;
                        and for BPA (Fig. 9) are methionine 441, asparagine 431 and
                        phenylalanine 442 again. This result implies that PHE442 plays a
                        relevant role in surface interactions. Finally, proper visualization
                        was possible with the Pymol tool [5]. It showed that the CBZ molecule
                        interacts on the surface (Fig. 7), on the other hand BPA is introduced
                        into the structure (Fig. 10) showing that this interaction primarily
                        occurs in the inside of the molecule.{" "}
                    </p>
                    <br></br>
                    <img
                        className="figure m-auto max-w-3xl"
                        src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/hydrophobic.png"
                        alt="Docking"
                    ></img>
                    <p className="text-xs text-center">
                        {" "}
                        <font className="font-bold"> Fig. 4 </font>
                        <i> Hydropath graphic [7]. </i>
                    </p>
                    <br></br>
                    <p className="text-xl">
                        {" "}
                        <font className="font-bold">
                            {" "}
                            <h3
                                id="Expression_and_purification_title"
                                className="text-3xl font-bold cano">Expression and purification</h3>{" "}
                        </font>
                    </p>
                    <br></br>
                    <p className="p-justify">
                        The aim of our project is to degrade EDCs in large volumes of water,
                        more specifically, on water used for crop irrigation in agriculture.
                        To achieve this, we must escalate our experiments from small, easily
                        reproducible assays of only a few milliliters of volume and milligrams
                        of EDCs, to a much bigger proportion, with volumes of hundreds of
                        cubic meters and bigger contaminant concentrations. This means that we
                        require vast amounts of protein in order to degrade the EDCs, and for
                        that express purpose it is necessary to produce a lot of protein, as
                        well as having a protocol in place to recuperate our recombinant
                        enzyme in an efficient manner. Two different laccases, the one from
                        Thermus thermophilus and the one from Trametes versicolor, were
                        utilized for our experimental procedures.{" "}
                    </p>
                    <br></br>
                    <p className="text-med">
                        {" "}
                        <font className="font-bold">
                            {" "}
                            Laccase from <i> Trametes versicolor </i> (LAC_TV_H22){" "}
                        </font>
                    </p>
                    <p className="p-justify">
                        <ol className="list-decimal list-outside">
                            <li>
                                Ligation of LAC_TV_HD22 (1864 base pairs) in pJET 1.2 Blunt vector
                                ( 2974 bp)(Thermofisher Scientific). We chose this vector because
                                its blunt ends facilitate ligation and resistance to Ampicillin. →
                                Result: plasmid LAC_TV (4838 bp).{" "}
                            </li>
                            <li>
                                Transformation was performed in the competent <i>E.coli</i> DH5 alpha
                                strain for a high plasmid production. We sow on petri plates LB
                                agar adding Ampicillin for the selection marker.{" "}
                            </li>
                            <li>
                                From the transformed plates; 4 candidate colonies were taken
                                corresponding to LAC_TV. Striated backups of each colony for
                                further plasmid extractions were done.{" "}
                            </li>
                        </ol>
                        {" "}
                    </p>
                    <br></br>
                    <img
                        src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/t-teccem-t3-rd.png"
                        alt="degra"
                        className="m-auto"
                    ></img>
                    <br></br>
                    <ol className="list-decimal list-outside">
                        <li>
                            {" "}
                            <i>E.coli</i> BL21 chemocompetent cells were transformed with “Plasmid
                            LAC_TV (8)”.
                        </li>
                        <li>
                            Afterwards, inoculation in a selective LB culture medium with
                            Ampicillin was performed for the protein expression and purification
                        </li>
                        {" "}
                    </ol>
                    <ul className="list-disc list-outside">
                        <li>
                            {" "}
                            For confirmation that the OmpA signal was working as intended, the
                            periplasmic protein was extracted following the procedure detailed
                            in protocol book page 7, and then compared to a control consisting
                            of BL21’s total protein. On figure 14, even though the control was
                            not as clearly visible as LacTV, there is a band that strongly
                            suggests the presence of the protein, as it fits the expected size,
                            it was found in the periplasmic region and it’s not plainly visible
                            on the control.
                        </li>
                        <li>
                            {" "}
                            Transformation on E. coli strain HMS174 was performed with Plasmid
                            LAC_TV (8). This was done to rule out the possibility that the BL21
                            expression system was at fault for the low expression of the enzyme.{" "}
                        </li>
                        <li>
                            {" "}
                            Laccase purification and expression on HMS174. A 500 mL batch of e.
                            coli transformed with the laccase plasmid was induced with IPTG and
                            harvested 24 hours after induction. Following the procedure detailed
                            in protocol book page 4, biomass obtained from this culture broth
                            was purified for the obtention of soluble protein. From the 52
                            protein fractions, only those with the highest absorbance were
                            sampled and analyzed in SDS-PAGEs to verify the presence of our
                            protein. The results were inconclusive, as there were no bands that
                            stood out in any of the purification fractions, nor were they
                            substantially different from the control. The resulting SDS-PAGEs
                            can be found on Fig. 15 and Fig. 16.{" "}
                        </li>
                    </ul>
                    <br></br>
                    <img
                        className="m-auto"
                        src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/t-teccem-t4-rd.png"
                        alt="Degrad"
                    ></img>{" "}
                    <br></br>
                    <p className="text-med">
                        {" "}
                        <font className="font-bold">
                            {" "}
                            Laccase from <i> Thermus thermophilus </i> (15A){" "}
                        </font>
                    </p>
                    <p className="p-justify">
                        <ol className="list-decimal list-outside">
                            <li>
                                Recuperation of the laccase (1486 base pairs) in pSB1C3 vector (
                                2070 bp) from iGem 2021 kit plate 2, well 15A. Other laccases
                                originating from Bacillus haloduran (15E), E. coli (13M), and
                                Bacillus pumilus (13I) were also obtained.{" "}
                            </li>
                            <li>
                                <i>E.coli</i> HMS174 and BL21DE3 chemocompetent cells were transformed
                                with the obtained plasmid in order to produce Thermus thermophilus
                                laccase. The other three obtained laccases were also transformed
                                and tested, but only the laccase from well 15A showed correct
                                overall expression in SDS-PAGE analysis, so we only conducted
                                further experiments with that one.
                            </li>
                            {" "}
                            <br></br>
                            Multiple SDS-PAGES were performed, they are listed below with their
                            respective photographs.<br></br>
                            <br></br>
                            <ul className="list-disc list-outside">
                                <li>
                                    Verifying the protein expression from our cloned bacterias,
                                    using as controls the natural competent <i>E.coli</i> HMS174 and
                                    BL21DE3 alpha strains. Only HMS174 strain after 27 hours of
                                    incubation presented a distinctive, big band that wasn’t present
                                    in any of the other samples (Fig. 17).{" "}
                                </li>
                                <li>
                                    SDS-PAGE of protein solubility; to seek for the protein in the
                                    soluble medium, insoluble fraction and extracellular protein.
                                    With this assay, we confirmed that the BL21DE3 strain wasn’t
                                    producing the protein, while the HMS174 was overexpressing it,
                                    as intended. This is further evidenced by the thick band around
                                    50 kDa present on the extracellular, soluble and insoluble
                                    fraction (lanes 6-8), but not on the induced control (lane 5).
                                    Fig. 18 illustrates it better.
                                </li>
                                {" "}
                            </ul>
                            {" "}
                            <br></br>
                            <img
                                src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/t-teccem-t5-rd.png"
                                alt="degra2"
                                className="m-auto"
                            ></img>
                            <br></br>
                            <li>
                                Two 1 liter batches of LB culture media were inoculated with our
                                recombinant bacteria to produce larger amounts of laccase 15A in
                                order to purify it. Batch one was purified utilizing Immobilized
                                Metal Affinity Chromatography (IMAC) utilizing Ni-NTA resin, and
                                only the soluble protein was purified, while batch two was
                                purified utilizing ionic Exchange Chromatography (IEC) using
                                Q-sepharose resin, and both the soluble and extracellular protein
                                was purified.{" "}
                            </li>
                            {" "}
                        </ol>
                        {" "}
                    </p>
                    <br></br>
                    <ul className="list-disc">
                        <li>
                            52 1 mL eluted fractions were obtained from each purification, and
                            absorbance was measured at 280 nm to quantify the fractions with the
                            most amount of protein. These absorbance values were plotted in
                            order to make chromatograms, visible in Fig. 19, Fig. 20 and Fig.
                            21. Utilizing the chromatograms, the fractions with the highest
                            absorbance values were analyzed in SDS-PAGE gels, aiming to find the
                            fractions where our protein might be present. In most cases, the
                            highest peaks were found between the 20th and the 35th fractions.
                            These fractions were then sampled and analyzed in SDS-PAGEs gels.
                        </li>
                        <br></br>
                        <img
                            src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/t-teccem-t6-rd.png"
                            alt="degra3"
                            className="m-auto"
                        ></img>
                        <br></br>
                        <li>
                            {" "}
                            When analyzing IMAC chromatography, it was found that the laccase
                            had bonded to nickel through its active site, compromising the
                            resin’s integrity and forming enzyme-substrate complexes that made
                            the protein appear bigger, as evidenced by the thick bands at around
                            70 kDa present in lanes 5-9 on gel 1 and 1-5 on gel 2, brand new
                            bands that aren’t visible on the flowthrough nor the solution before
                            purification, which are lanes 2 and 1, respectively (Fig. 22 and
                            Fig. 23).
                        </li>
                        <br></br>
                        <img
                            src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/t-teccem-t7-rd.png"
                            alt="degra4"
                            className="m-auto"
                        ></img>
                        <br></br>
                        <li>
                            {" "}
                            In IEC chromatography, there was a vast difference between the
                            soluble and extracellular protein’s profiles is evident, with
                            soluble laccase eluting from fraction 22 onwards, while the biggest
                            concentration of our recombinant enzyme in the extracellular
                            fraction appeared to be in fractions as early as the first one all
                            the way to the 26th. The team believes this is due to the high
                            concentration of salts present in the media, since we precipitated
                            the protein with ammonium sulfate, drastically altering the protein
                            charges, with some atypical values on 4th and 5th lanes of the
                            extracellular protein’s gel 2. This might be due to a potential
                            wrong labeling of the samples, as the profile of sample 38 and 40
                            matches the soluble protein’s intensity from samples 28 and 30,
                            approximately (Fig. 24 - Fig. 27)
                        </li>
                        {" "}
                        <br></br>
                        <img
                            src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/t-teccem-t8v2-rd.png"
                            alt="degra4"
                            className="m-auto"
                        ></img>
                        <br></br>
                    </ul>
                    <p className="text-xl">
                        {" "}
                        <font className="font-bold">
                            {" "}
                            <h3
                                id="Functionality_assays_title"
                                className="text-3xl font-bold cano">Functionality assays </h3>{" "}
                        </font>
                    </p>
                    <br></br>
                    <p className="text-med">
                        {" "}
                        <font className="font-bold"> Malachite Green qualitative assay </font>
                    </p>
                    <p className="p-justify">
                        Here below we show a colorimetric assay involving the immobilized
                        laccase and the colorant malachite green. Malachite green has shown to
                        be a very effective substrate for laccase because an effective
                        degradation has been observed: 100% after 15 hours of incubation [12].{" "}
                    </p>
                    <br></br>
                    <p className="p-justify">
                        The experimentals (E1 and E2) contained immobilized laccase (1 mg/mL),
                        M.G. colorant (0.7%) and citrate buffer pH 5.0, 0.1 M. Results
                        revealed a color elimination in these vials. They were blue at the
                        beginning as control 1 (C1) which only contained citrate buffer and
                        milli Q water. This transformation occurred after 1 hour of incubation
                        at 37°C demonstrating that the immobilized laccase is able to degrade
                        the dye. Control 2 (C2) shows a change in the color, demonstrating
                        that the zeolite is able to absorb the colorant by itself (Fig. 29).
                        Contrasting the results between E1 and E2 with C2, we consider that
                        there is a possibility that the elimination of the color is being
                        realized only by the zeolite; and that laccase is somehow helping but
                        its enzymatic activity is unknown. We also added control 4 (C4) which
                        contains M.G. colorant with buffer citrates and laccase, in this vial
                        blue color elimination is observed due to the enzymatic activity of
                        free commercial laccase (Fig. 28).{" "}
                    </p>
                    <br></br>
                    <img
                        src="https://static.igem.wiki/teams/4260/wiki/malachitezeoexperiment.png"
                        alt="degra5"
                        className="m-auto max-w-3xl"
                    ></img>
                    <br></br>
                    <p className="text-xs text-center">
                        {" "}
                        <font className="font-bold"> Fig. 28 </font>
                        <i>
                            {" "}
                            Functionality assays of immobilized laccase with malachite green.
                            Water (Milli Q water), Zeo (zeolite), MG (malachite green), Lac
                            (laccase). Experimentals and controls were exposed to the same
                            incubation conditions (37°C for 60 minutes) and in this picture
                            degradation of the colorant is shown (E1 and E2), but also in
                            control 2, which demonstrates that zeolite is able to eliminate the
                            blue color by itself. [7].{" "}
                        </i>
                    </p>
                    <br></br>
                    <img
                        src="https://static.igem.wiki/teams/4260/wiki/zeolitemalachitenofondo.png"
                        alt="degra6"
                        className="m-auto max-w-xl"
                    ></img>
                    <br></br>
                    <p className="text-xs text-center">
                        {" "}
                        <font className="font-bold"> Fig. 29 </font>
                        <i>
                            {" "}
                            Adsorption of the color by zeolite. These results imply that the
                            color is being depleted by zeolite and enzymatic activity of laccase
                            is unknown.
                        </i>
                    </p>
                    <br></br>
                    <p className="text-med">
                        {" "}
                        <font className="font-bold"> Guaiacol qualitative assay </font>
                    </p>
                    <p className="p-justify">
                        It is reported by Jiang et al, 2010, that the laccase is able to
                        catalyze the oxidation of guaiacol substrate to form red particles
                        [13]. Although it is also reported that it is possible to measure and
                        quantify laccase functionality by means of a spectrophotometric assay
                        [13], for practical purposes and convenience, we made the decision to
                        evaluate the laccase functionality qualitatively, so that if a color
                        changes from colorless to red, it is determined that the laccase is
                        functional.{" "}
                    </p>
                    <br></br>
                    <p className="p-justify">
                        Below, we present the results of a series of colorimetric qualitative
                        assays performed to evaluate the functionality of the free commercial
                        laccase, purified laccases and the immobilizations carried out using
                        guaiacol as a substrate.{" "}
                    </p>
                    <br></br>
                    <p className="p-justify">
                        In order to check and verify that the assay serves the purpose
                        previously mentioned , we first performed a control experiment using
                        free commercial laccase under different conditions and assessed the
                        observable colorimetric changes. The experiment was run in 2 mL
                        microtubes containing laccase (1 mg/mL), distilled water, acetates
                        buffer (10 mM pH 5) and guaiacol (2.5 or 5 mM) depending on the tube
                        as shown in Fig. 30, at room temperature.{" "}
                    </p>
                    <br></br>
                    <img
                        src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/guaiacol-1-control-assay1.png"
                        alt="degra7"
                        className="m-auto max-w-xl"
                    ></img>
                    <br></br>
                    <p className="text-xs text-center">
                        {" "}
                        <font className="font-bold"> Fig. 30 </font>
                        <i>
                            Results of control experiment assay to evaluate laccase
                            functionality using guaiacol as substrate.
                        </i>
                    </p>
                    <br></br>
                    <p className="p-justify">
                        It was possible to observe that the oxidation reaction that occurs
                        between laccase and guaiacol generates indeed a colorimetric change.
                        Likewise, it is concluded that the acetate buffer is suitable for the
                        experiment because it does not generate any interference, since, as
                        observed in tube 1 (Fig. 30), there is no colorimetric change when
                        laccase is in contact with the buffer. <br></br>
                        Once the experiment was started, it was observed that the minimum
                        incubation time to observe significant changes in the color of the
                        sample is 30 minutes when incubated at room temperature. However, it
                        is worth mentioning that, being a qualitative assay, the incubation
                        time does not affect the results significantly if the minimum
                        incubation time of 30 minutes is met. <br></br>
                        Finally, through this experiment, the decision was made to perform the
                        subsequent tests with guaiacol with a concentration of 2.5 mM (tube
                        3), since there is no significant observable difference in relation to
                        the experiment containing guaiacol with a concentration of 5 mM (tube
                        2).<br></br>
                        Then, based on the above results and conclusions, the documented photo
                        was used as a reference and the protocol for the guaiacol
                        functionality assays was designed (see protocol book p. 13). The
                        results shown below were obtained following this protocol.
                    </p>
                    <br></br>
                    <p className="text-med">
                        {" "}
                        <font className="font-bold">
                            {" "}
                            Purified laccase fractions functionality{" "}
                        </font>
                    </p>
                    <p className="p-justify">
                        After the purification of extracellular and soluble laccases, several
                        fractions were obtained and those with higher absorbance readings and
                        observably more abundant in the SDS Page experiment were analyzed. The
                        guaiacol functionality assay was carried out and after 30 minutes
                        incubation at room temperature, the results shown in Fig. 31 were
                        obtained.{" "}
                    </p>
                    <br></br>
                    <img
                        src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/guaiacol-2-purifiedlaccases.png"
                        alt="degra8"
                        className="m-auto max-w-xl"
                    ></img>
                    <br></br>
                    <p className="text-xs text-center">
                        {" "}
                        <font className="font-bold"> Fig. 31 </font>
                        <i>
                            Results of experimental assay to evaluate different purified laccase
                            fractions functionality using guaiacol as substrate.
                        </i>
                    </p>
                    <br></br>
                    <p className="p-justify">
                        As the fractions were supposed to contain purified laccase, it was
                        expected to observe a colorimetric change in every tube. Since there
                        was no significant difference compared to the control experiment assay
                        (Fig. 30), it was concluded that the laccases, if there were any
                        present in the analyzed fractions, were not functional.{" "}
                    </p>
                    <br></br>
                    <p className="text-med">
                        {" "}
                        <font className="font-bold"> Laccase 15A functionality </font>
                    </p>
                    <p className="p-justify">
                        After the purification of laccase 15A, several fractions were obtained
                        and those with higher absorbance readings and observably more abundant
                        in the SDS Page experiment were analyzed. The guaiacol functionality
                        assay was carried out by triplicate to verify and increase the
                        reliability of the experiment and after 30 minutes incubation at room
                        temperature, the results shown in Fig. 32 were obtained.{" "}
                    </p>
                    <br></br>
                    <img
                        src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/guaiacol-3-laccase15a1.png"
                        alt="degra9"
                        className="m-auto max-w-xl"
                    ></img>
                    <br></br>
                    <p className="text-xs text-center">
                        {" "}
                        <font className="font-bold"> Fig. 32 </font>
                        <i>
                            Results of experimental assay to evaluate laccase 15A functionality
                            using guaiacol as substrate.{" "}
                        </i>
                    </p>
                    <br></br>
                    <p className="p-justify">
                        It was expected to observe a colorimetric change in every tube, except
                        for the negative control. Since there was no perceptible change, it
                        was concluded that the laccases present in the analyzed samples were
                        not functional.{" "}
                    </p>
                    <br></br>
                    <p className="text-med">
                        {" "}
                        <font className="font-bold">
                            {" "}
                            September 06 immobilization functionality{" "}
                        </font>
                    </p>
                    <p className="p-justify">
                        The guaiacol functionality assay was carried out to assess the
                        enzymatic activity of the first three immobilization samples obtained
                        experimentally. The experiment was conducted by duplicate to verify
                        and increase its reliability and after 30 minutes incubation at room
                        temperature, the results shown in Fig. 33 were obtained.{" "}
                    </p>
                    <br></br>
                    <img
                        src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/guaiacol-4-immobilization1.png"
                        alt="degra10"
                        className="m-auto max-w-xl"
                    ></img>
                    <br></br>
                    <p className="text-xs text-center">
                        {" "}
                        <font className="font-bold"> Fig. 33 </font>
                        <i>
                            Results of experimental assay to evaluate first immobilization
                            functionality using guaiacol as substrate.{" "}
                        </i>
                    </p>
                    <br></br>
                    <p className="p-justify">
                        It was expected to observe a colorimetric change in every tube, except
                        for the negative control. Since there was no perceptible change, it
                        was concluded that the immobilized laccases present in the analyzed
                        samples were not functional.{" "}
                    </p>
                    <br></br>
                    <p className="text-med">
                        {" "}
                        <font className="font-bold">
                            {" "}
                            September 10 immobilization functionality{" "}
                        </font>
                    </p>
                    <p className="p-justify">
                        The guaiacol functionality assay was carried out to assess the
                        enzymatic activity of two more immobilization samples obtained
                        experimentally. The experiment was conducted by duplicate to verify
                        and increase its reliability and after 30 minutes incubation at room
                        temperature, the results shown in Fig. 34 were obtained.
                    </p>
                    <br></br>
                    <img
                        src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/guaiacol-5-immobilization2.png"
                        alt="degra11"
                        width="800"
                        className="m-auto max-w-xl"
                    ></img>
                    <br></br>
                    <p className="text-xs text-center">
                        {" "}
                        <font className="font-bold"> Fig. 34 </font>
                        <i>
                            Results of experimental assay to evaluate second immobilization
                            functionality using guaiacol as substrate.
                        </i>
                    </p>
                    <br></br>
                    <p className="p-justify">
                        It was expected to observe a colorimetric change in every tube, except
                        for the negative control. Since there was no perceptible change, it
                        was concluded that the immobilized laccases present in the analyzed
                        samples were not functional.<br></br>
                        Regarding the evaluation of the functionality of the immobilizations,
                        both those performed on September 6 and 10, and based on the results
                        obtained when performing the malachite green assay, we decided to
                        check if the zeolite present in the immobilization samples is causing
                        interference in the guaiacol assays. Taking into account the ability
                        of the zeolite to degrade colorant, the evaluation of the degree to
                        which the zeolite degrades the colorant was carried out. So that we
                        can verify if the functionality tests with immobilized laccase do not
                        present a colorimetric change due the degradation of the colorant
                        carried out by the zeolite.{" "}
                    </p>
                    <br></br>
                    <p className="text-med">
                        {" "}
                        <font className="font-bold">
                            {" "}
                            Evaluation of zeolite colorant degradation{" "}
                        </font>
                    </p>
                    <p className="p-justify">
                        The assay was performed in parts, first the guaiacol functionality
                        assay was carried out using a free commercial laccase solution to
                        ensure a colorimetric change, and after an hour incubation free
                        zeolite (synthesized by our team) was added to see if there were any
                        perceptible changes in the intensity of the sample color. As controls,
                        we decided to work with zeolite free and laccase free samples, which
                        were then used as references.<br></br>
                        The experiment was carried out by triplicate to verify and increase
                        the reliability of the experiment and after an hour of total
                        incubation at room temperature, the results shown in Fig. 35 were
                        obtained.
                    </p>
                    <br></br>
                    <img
                        src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/guaiacol-6-zeolitedegra.png"
                        alt="degra12"
                        width="800"
                        className="m-auto max-w-xl"
                    ></img>
                    <br></br>
                    <p className="text-xs text-center">
                        {" "}
                        <font className="font-bold"> Fig. 35 </font>
                        <i>
                            Results of experimental assay to evaluate second immobilization
                            functionality using guaiacol as substrate.
                        </i>
                    </p>
                    <br></br>
                    <p className="p-justify">
                        It was expected to observe a reddish coloration in every tube, except
                        for the laccase free control, which was indeed observed. After the
                        addition of the free zeolite the colorant was degraded to a certain
                        level as shown in Fig. 36. In order to quantify the colorant
                        degradation we performed a series of spectrophotometric scannings
                        analyzing the wavelength from 270 to 500 nm. The results were plotted
                        and the graphs obtained are presented in Fig. 36, Fig. 37 and Fig. 38.{" "}
                    </p>
                    <br></br>
                    <img
                        src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/t-teccem-t9-rd.png"
                        alt="degra13"
                        className="m-auto"
                    ></img>
                    <br></br>
                    <p className="p-justify">
                        Based on the constructed graphs and on the guaiacol assay results, it
                        is possible to conclude that indeed the zeolite degrades the colorant
                        formed by the oxidation of the guaiacol. Nevertheless, the colorant
                        degradation is minimum in comparison with the colorimetric change
                        produced by the oxidation reaction, so we assume that the lack of
                        observable colorimetric change in the immobilization functionality
                        assays using guaiacol as substrate is the result of the lack of
                        functional lacasses.{" "}
                    </p>
                    <br></br>
                    <p className="text-med">
                        {" "}
                        <font className="font-bold">
                            {" "}
                            Purified laccase TV fractions functionality{" "}
                        </font>
                    </p>
                    <p className="p-justify">
                        After the purification of laccase TV, several fractions were obtained
                        and those with higher absorbance readings and observably more abundant
                        in the SDS Page experiment were analyzed. The guaiacol functionality
                        assay was carried out and after 30 minutes incubation at room
                        temperature, the results shown in Fig. 39 were obtained.{" "}
                    </p>
                    <br></br>
                    <img
                        src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/guaiacol-7-laccasetv.png"
                        alt="degra15"
                        className="m-auto max-w-xl"
                    ></img>
                    <br></br>
                    <p className="text-xs text-center">
                        {" "}
                        <font className="font-bold"> Fig. 39 </font>
                        <i>
                            Results of experimental assay to evaluate different purified laccase
                            TV fractions functionality using guaiacol as substrate.
                        </i>
                    </p>
                    <br></br>
                    <p className="p-justify">
                        As the fractions were supposed to contain purified TV. laccase, it was
                        expected to observe a colorimetric change in every tube, except for
                        the negative control. Since there was no significant difference
                        compared to the control experiment assay (Fig. 30), it was concluded
                        that the laccases, if there were any, present in the analyzed
                        fractions were not functional.{" "}
                    </p>
                    <br></br>
                    <p className="text-xl">
                        {" "}
                        <font className="font-bold">
                            {" "}
                            <h3
                                id="Immobilization_title"
                                className="text-3xl font-bold cano">Immobilization of laccase in the ZIF</h3>{" "}
                        </font>
                    </p>
                    <br></br>
                    <p className="p-justify">
                        In the verification and testing stage of our system, we carried out
                        three different phases where different aspects were analyzed. First,
                        size distribution and suspension stability by means of the DLS
                        technique. Second, morphology and dry behavior, with the help of SEM.
                        Finally, the study of enzymatic stability and immobilization density
                        through spectrophotometric analysis.{" "}
                    </p>
                    <br></br>
                    <p className="text-med">
                        {" "}
                        <font className="font-bold"> DLS Analysis </font>
                    </p>
                    <p className="p-justify">
                        Dynamic Light Scattering (DLS) is a technique that, by studying the
                        modification of a light beam incident on a sample, measures the size
                        and distribution of particles suspended in a medium. We performed this
                        analysis to study the particle size resulting from the immobilization,
                        for this it was necessary to take a little of the sample and the
                        control solution (same components of the immobilization, but without
                        including enzyme) in its last wash still in suspension and take him to
                        the Zetasizer team. The size distribution graphs are shown in Fig. 40
                        and Fig. 41.{" "}
                    </p>
                    <br></br>
                    <img
                        src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/dls11.png"
                        alt="diam 5"
                        className="m-auto max-w-3xl"
                    ></img>
                    <p className="text-xs text-center">
                        {" "}
                        <font className="font-bold"> Fig. 40 </font>
                        <i>Distribution and size of particles in the control solutions.</i>
                    </p>
                    <br></br>
                    <img
                        src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/dls21.png"
                        alt="diam 6"
                        className="m-auto max-w-3xl"
                    ></img>
                    <p className="text-xs text-center">
                        {" "}
                        <font className="font-bold"> Fig. 41 </font>
                        <i>
                            Distribution and size of particles in the immobilization solutions.
                        </i>
                    </p>
                    <br></br>
                    <p className="p-justify">
                        As we can see, in that control solution in which we only have synthesized zeolite,
                        the average size of the suspended particles is 2355 nanometers, while when we analyze
                        the immobilized enzyme particles, larger sizes stand out, around 7800 nm. This indicates
                        the growth of the support structure to be able to contain the protein inside.{" "}
                    </p>
                    <br></br>
                    <p className="text-med">
                        {" "}
                        <font className="font-bold"> SEM Analysis </font>
                    </p>
                    <p className="p-justify">
                        Scanning Electron Microscopy (SEM) is a technique that uses a beam of electrons incident on a
                        sample to observe its surface and morphology. As with the previous test, our immobilization
                        sample
                        and a control with only zeolite were analyzed.<br></br>
                        In addition to being able to measure its size and observe its morphology, this type of
                        characterization
                        is important to understand the surface characteristics of our material. In the case of zeolite,
                        it stands out
                        for having a high surface area and for being a support with high internal and external porosity,
                        as well as
                        cavities with uniform structures. These characteristics, as well as the variation in size within
                        the samples,
                        can be seen in Fig. 42.
                        {" "}
                    </p>
                    <br></br>
                    <img
                        src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/sem1.png"
                        alt="diam 6"
                        className="m-auto max-w-3xl"
                    ></img>
                    <p className="text-xs text-center">
                        {" "}
                        <font className="font-bold"> Fig. 42 </font>
                        <i>
                            (Top) Control surface images. (Bottom) Immobilization surface images.
                        </i>
                    </p>
                    <br></br>
                    <p className="p-justify">
                        The images show the different morphology and size that the samples acquire when they
                        contain or not the immobilized enzyme. The largest being those immobilized samples.
                        Similarly, the distribution they acquire when applied to a semi-porous surface such as
                        glass can be observed.{" "}
                    </p>
                    <br></br>
                    <p className="text-med">
                        {" "}
                        <font className="font-bold"> UV-VIS spectrophotometric analysis of immobilization
                            washings </font>
                    </p>
                    <p className="p-justify">
                        The supernatants of the washings of the immobilization carried out, as well as of the control
                        solution were reserved to use it as a blank and were analyzed by means of Ultraviolet-Visible
                        Spectrophotometry. The reported graphs are the following Fig. 43:{" "}
                    </p>
                    <br></br>
                    <img
                        src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/uvvis2.png"
                        alt="diam 6"
                        width="1000"
                        className="m-auto max-w-3xl"
                    ></img>
                    <p className="text-xs text-center">
                        {" "}
                        <font className="font-bold"> Fig. 43 </font>
                        <i>
                            Four Supernatants Analysis Spectrums.
                        </i>
                    </p>
                    <br></br>
                    <p className="p-justify">
                        It is generally known, as well as reported in various research articles, that proteins manage
                        their absorbance spectrum in an average range of 280 nm. If we observe the graphs, we can notice
                        that in the supernatant resulting from the first wash there is a high absorbance reading in the
                        range of 280 nm, this indicates the presence of our enzyme in the medium.<br></br>

                        Finding a high concentration in the first wash and a technically zero concentration in the rest
                        indicates that the immobilization was unstable under the wash conditions and broke the
                        enzyme-substrate interaction.
                        This break is attributed to 2 factors. First, to the change in pH in the medium, in the first
                        supernatant analyzed
                        the solvent in the solution is an acetate buffer at 5 pH, while that of the first wash was
                        distilled water, the change
                        in pH may have weakened the interaction. The second point is the pressure exerted on the sample,
                        since the washing was
                        carried out at 6000 rpm for 15 minutes, the interaction between the substrate and the enzyme in
                        the trapping system for
                        immobilization was by means of static charges, lower than those ionic or covalent, so the
                        pressure exerted could have
                        been greater and break the interaction, releasing the enzyme.<br></br>

                        With the results obtained, the need to increase the interaction strength between our enzyme
                        (Laccase from Trametes versicolor)
                        and the substrate (zeolite) stands out. This interaction can be increased by promoting the
                        formation of different types of
                        bonds such as ionic or covalent.<br></br>

                        For this, the functionalization of the surface of our substrate is required, in such a way that
                        it favors the polar
                        charges present in the structure of the enzyme. To achieve this objective, a dendritic-type
                        structure could be
                        generated on the surface of the zeolite, based on what is reported in the literature, generating
                        bonds activated
                        with glutaraldehyde promotes covalent interactions with laccase, which would help us to obtain a
                        more stable
                        immobilization before different environmental conditions.
                        {" "}
                    </p>
                    <br></br>
                    <p className="text-med">
                        {" "}
                        <font className="font-bold"> Degradation of BPA assays </font>
                    </p>
                    <p className="p-justify">
                        It is important to analyze the efficiency of the degradation of the endocrine disrupting
                        chemicals (EDCs)
                        by immobilized laccase and by free laccase, in order to compare both and evaluate the results.
                        Unfortunately,
                        immobilized laccase was not taken into account because it resulted that laccase and zeolite
                        interactions were
                        weak and got broken, as previously described in immobilization results. However, we developed
                        the degradation of
                        the bisphenol A, with a commercial laccase. Firstly we have developed the standard curves that
                        will help us to
                        determine the concentration of EDCs once laccase was added to the experimentals (see Fig. 44).
                        Finally, the
                        percentage of degradation is shown in Fig. 45 and data results in table DC. The results show
                        that the maximum
                        degradation is 44.7% at 48 hours. Assay was conducted for 72 hours at room temperature, pH of
                        5.0 and 300 rpm.
                        Experimentals contained buffer, laccase and bisphenol A, blanks contained only laccase and
                        buffer and controls
                        contained bisphenol A and buffer. Controls showed constant values (data not shown){" "}
                    </p>
                    <br></br>
                    <img
                        width="800"
                        className="m-auto max-w-xl"
                        src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/lacbpastandardcurve.png"
                        alt="diam 6"
                    ></img>
                    <p className="text-xs text-center">
                        {" "}
                        <font className="font-bold"> Fig. 44 </font>
                        <i>
                            Standard curve to obtain concentration of BPA in the degradation. Linear equation is shown
                            with the determination coefficient of 0.877.
                        </i>
                    </p>
                    <br></br>
                    <img
                        className="m-auto max-w-xl"
                        src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/degpercent.png"
                        alt="diam 6"
                    ></img>
                    <p className="text-xs text-center">
                        {" "}
                        <font className="font-bold"> Fig. 45 </font>
                        <i>
                            Degradation of Bisphenol A with commercial laccase.
                        </i>
                    </p>
                    <br></br>
                    <p className="text-xs text-center">
                        {" "}
                        <font className="font-bold"> Table 2: </font>
                        <i>
                            Data of the degradation of BPA with commercial laccase. Assay lasted for 72 hours and
                            maximum degradation is 45% at 48 hours.
                        </i>
                    </p>
                    <img
                        className="m-auto max-w-xl"
                        src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/degpercenttable.png"
                        alt="diam 6"
                    ></img>
                    <br></br>
                    <p className="text-med">
                        {" "}
                        <font className="font-bold"> Kinetic Parameters </font>
                    </p>
                    <p className="p-justify">
                        In order to learn about the behavior of the laccase with bisphenol A as substrate. We have
                        evaluated
                        the volumetric enzymatic activity (Vmax) and Km using Lineweaver-Burk adjustment (Fig. 46) and
                        following
                        Michaelis-Menten kinetics (Fig. 47). The reason we developed this analysis is because we haven't
                        seen in
                        literature an assay showing these kinetic parameters with bisphenol A as substrate, that's why
                        we consider
                        this important in order to evaluate the performance of the enzyme. According to the data
                        obtained from the
                        degradation assays, we obtained that Vmax is 1.47x10-5 mM/s and Km is 1.67x10-1 mM.{" "}
                    </p>
                    <br></br>
                    <img
                        className="m-auto max-w-xl"
                        src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/degburke.png"
                        alt="diam 6"
                    ></img>
                    <p className="text-xs text-center">
                        {" "}
                        <font className="font-bold"> Fig. 46 </font>
                        <i>
                            Lineweaver-Burk adjustment used to calculate the kinetic parameters of the laccase.
                        </i>
                    </p>
                    <br></br>
                    <img
                        width="800"
                        className="m-auto max-w-xl"
                        src="https://static.igem.wiki/teams/4260/wiki/laboratory/results-degradaci-n/kineticparametersfig-2.png"
                        alt="diam 6"
                    ></img>
                    <p className="text-xs text-center">
                        {" "}
                        <font className="font-bold"> Fig. 47 </font>
                        <i>
                            Kinetic parameters obtained with Michaelis-Menten kinetics.
                        </i>
                    </p>
                    <br></br>
                    <h3
                        id="CBZ_on_plants_title"
                        className="text-3xl font-bold cano">
                        Effects of carbamazepine in lettuce
                    </h3>
                    <p className="p-justify">
                        Since the project is based on the contamination of agricultural crops by EDCs, we have made
                        an experimental analysis in lettuces. These lettuces were irrigated with Carbamazepine in
                        different
                        concentrations and different time periods. We cultivated and made an experiment with 27 lettuce
                        plants,
                        the irrigation time was 8 days, 15 days or 22 days with the concentrations of CBZ of 4.5 mg/mL
                        or 45 mg/mL.
                        The objective is to see and assess the carbamazepine effects on their development and growth. We
                        analyzed
                        root length, the leaf length and chlorophyll content, including A and B (following the protocol
                        on page 11
                        of the protocol book), however due to inconsistent results measuring the absorbances and
                        extracting the
                        chlorophyll, these measurements are not shown. Some of our experimentals are shown in the next
                        figures.{" "}
                    </p>
                    <br></br>
                    <img
                        className="m-auto max-w-3xl"
                        src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/t-teccem-t10-rd.png"
                        alt="diam 6"
                    ></img>
                    <img
                        width="800"
                        className="m-auto max-w-3xl"
                        src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/fig51-53.png"
                        alt="diam 6"
                    ></img>
                    <img
                        width="800"
                        className="m-auto max-w-3xl"
                        src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/fig54-56.png"
                        alt="diam 6"
                    ></img>
                    <img
                        className="m-auto max-w-3xl"
                        src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/t-teccem-t13-rd.png"
                        alt="diam 6"
                    ></img>
                    <br></br>
                    <p className="text-med">
                        {" "}
                        <font className="font-bold"> Statistical analysis </font>
                    </p>
                    <p className="p-justify">
                        The statistical analysis consisted in obtaining the average of the variables measured
                        (leaf length, root length, content of chlorophyll A and B) to obtain the significance of
                        the effects caused by the CBZ concentration and time exposure in an ANOVA analysis.
                        These results were obtained with the Minitab program [14].{" "}
                    </p>
                    <br></br>
                    <img
                        className="m-auto max-w-3xl"
                        src="https://static.igem.wiki/teams/4260/wiki/results-degradaci-n/22leaf1.png"
                        alt="diam 6"
                    ></img>
                    <p className="text-xs text-center">
                        {" "}
                        <font className="font-bold"> Fig. 58 </font>
                        <i>
                            Leaf length (cm) analysis of lettuces exposed to 4.5 mg/mL and 45 mg/mL and 8 and 22 days of
                            exposure.
                        </i>
                    </p>
                    <br></br>
                    <p className="p-justify">
                        This shows the statistical analysis of leaf size of lettuces that were exposed to 4.5 mg/mL and
                        45 mg/mL
                        of CBZ for between 8 and 22 days. In subsection A, the value of the adjusted determination
                        coefficient is
                        observed, which indicates 70.3% of the variability that exists due to the factors of CBZ
                        concentration and
                        exposure time, which should ideally be as close to 100% as possible. This result is due to the
                        error of the
                        experimental part and measurements, although is the greatest determination coefficient we
                        obtained. In section
                        B on the analysis of variants, it is observed, according to our hypothesis, that the p-values
                        ​​of CBZ and exposure
                        time are taken as significant by having a value less than 𝛼, contrary to the interaction between
                        both factors
                        that were not significant. In part C of the Pareto table, the dotted line at 2.306 indicates
                        that the factors of
                        CBZ and the exposure time are significant since they exceed the line, in the same way it is
                        observed that the
                        interaction between both factors is not significant, as we had seen in section B. In section D
                        it is observed
                        a surface graph which shows the difference in size of the experimental lettuce with the control.
                        This graph
                        shows that at higher exposure time and concentration of CBZ there was a greater difference in
                        size in the lettuce,
                        but at lower concentration of CBZ and time of exposure there was less difference. This result is
                        the most reliable
                        between the 2 previous experiments since the adjusted determination coefficient is the nearest
                        to 100%.{" "}
                    </p>
                    <br></br>
                    <h3
                        id="References_title"
                        className="text-3xl font-bold cano">
                        References
                    </h3>
                    <p className="reference">
                        [1] SnapGene software (www.snapgene.com)
                    </p>
                    <p className="reference">
                        [2] Benchling [Biology Software]. (2022). Retrieved from https://benchling.com.
                    </p>
                    <p className="reference">
                        [3] Hebditch and Warwicker (2019).Web-based display of protein surface and pH-dependent
                        properties
                        for assessing the developability of biotherapeutics. Scientific Reports.
                    </p>
                    <p className="reference">
                        [4] iGEM UCL London (2012). Welcome to plastic Republic.
                        https://2012.igem.org/Team:University_College_London
                    </p>
                    <p className="reference">
                        [5] The PyMOL Molecular Graphics System, Version 2.0 Schrödinger, LLC.
                    </p>
                    <p className="reference">
                        [6] Price, N. C., & Stevens, L. (1989). Fundamentals of enzymology.
                    </p>
                    <p className="reference">
                        [7] Gasteiger E., Hoogland C., Gattiker A., Duvaud S., Wilkins M.R., Appel R.D., Bairoch A.;
                        Protein Identification and Analysis Tools on the ExPASy Server; (In) John M. Walker (ed):
                        The Proteomics Protocols Handbook, Humana Press (2005). pp. 571-607
                    </p>
                    <p className="reference">
                        [8] Eberhardt, J., Santos-Martins, D., Tillack, A.F., Forli, S. (2021). AutoDock Vina 1.2.0:
                        New Docking Methods, Expanded Force Field, and Python Bindings. Journal of Chemical Information
                        and Modeling.
                    </p>
                    <p className="reference">
                        [9] Trott, O., & Olson, A. J. (2010). AutoDock Vina: improving the speed and accuracy of docking
                        with a new scoring
                        function, efficient optimization, and multithreading. Journal of computational chemistry, 31(2),
                        455-461.
                    </p>
                    <p className="reference">
                        [9] Trott, O., & Olson, A. J. (2010). AutoDock Vina: improving the speed and accuracy of docking
                        with a new scoring
                        function, efficient optimization, and multithreading. Journal of computational chemistry, 31(2),
                        455-461.
                    </p>
                    <p className="reference">
                        [10] UCSF Chimera--a visualization system for exploratory research and analysis. Pettersen EF,
                        Goddard TD, Huang CC,
                        Couch GS, Greenblatt DM, Meng EC, Ferrin TE. J Comput Chem. 2004 Oct;25(13):1605-12.
                    </p>
                    <p className="reference">
                        [11] Schöning-Stierand, K.; Diedrich, K.; Fährrolfes, R.; Flachsenberg, F.; Meyder, A.;
                        Nittinger, E.; Steinegger,
                        R.; Rarey, M. (2020). ProteinsPlus: interactive analysis of protein–ligand binding interfaces.
                        Nucleic Acids Research,
                        48:W48-W53.
                    </p>
                    <p className="reference">
                        [12] iGEM Tec CEM. (2021). Disrupting Disruptors. https://2021.igem.org/Team:TecCEM
                    </p>
                    <p className="reference">
                        [13] Caina Jiang; Shaoming Ling; Pengfei Wang; Aihui Liang; Bin Chen; Guiqing Wen; Zhiliang
                        Jiang (2011).
                        A new and sensitive catalytic resonance scattering spectral assay for the detection of laccase
                        using guaiacol
                        as substrate. , 26(6), 500–505. doi:10.1002/bio.1259
                    </p>
                    <p className="reference">
                        [14] Arend, Dominic N. (1993). Choices (Version 4.0) [Computer software]. Champaign, IL: U.S.
                        Army Corps of
                        Engineers Research Laboratory. (CERL Report No.CH7-22510)
                    </p>
                    <br></br>

                    <br></br> <br></br>
                </div>
            </div>
        </div>
    )
}


